import React from 'react';
import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import MasterLog from '../../../shared/enums/master-log-enum';
import ShClockIcon from '../../../shared/components/images/sh-clock';
import { getOffset } from '../../../shared/utils/time-conversions';
import ImageIcon from '../../../shared/components/images/image-icon';
import { Images } from '../../../shared/app-constants';

const UnifiedInboxActivityTile = ({
  timestamp,
  log,
  type,
  timezone,
  className,
}) => {
  const { t } = useTranslation();

  const time = DateTime.fromISO(timestamp, { zone: timezone }).toFormat(
    'hh:mm a',
  );

  const getActivityLabel = () => {
    if (type === MasterLog.UniboxEmailOpened) {
      return `${t('labels.email')} ${t('labels.opened')}`;
    }

    if (type === MasterLog.UniboxEmailLinkClicked) {
      return `${t('labels.link_clicked')}`;
    }

    return '';
  };

  const link = log?.link?.link || '';

  const showlink =
    link &&
    type === MasterLog.UniboxEmailLinkClicked &&
    (className !== 'prospect-kanban-email-thread-activity-modal' ? (
      <div className="link-wrapper d-flex align-items-center">
        <ImageIcon src={Images.LinkChain} />
        <div className="activity-link-clicked">
          <span>{link}</span>
          <span className="tooltiptext">{log.link.link}</span>
        </div>
      </div>
    ) : (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {link}
      </a>
    ));

  return (
    <div className="activity-item">
      <div className="d-flex align-items-center">
        <div className="activity-label font-medium mr-3">
          {getActivityLabel()}
        </div>
        <div className="activity-log font-12">
          <ShClockIcon /> {time} (GMT {getOffset(timestamp, timezone)}){' '}
          {timezone}{' '}
        </div>
      </div>
      <div className="tooltip-wrapper activity-link">{showlink}</div>
    </div>
  );
};

export default UnifiedInboxActivityTile;
